import React, { useState } from "react";
import Position from "./position.tsx";
import styles from "./position.module.scss";

export default function Experience() {
  return (
    <>
      <div className={styles.experienceTitle}>
        Where I gained or improved my skills:
      </div>
      <Position
        dateFrom="2021-06"
        dateTo="Current"
        positionName="Product specialist"
        description={`
        - Developing and maintaining User API documentation
        - Manual testing initial products
        - Technical troubleshooting 
        - Mentoring in the workplace about internal systems
        - Project management
  `}
        imageLocation="../perveskLogo.png"
        jobUrl="https://pervesk.lt/en/"
      />
      <Position
        dateFrom="2020-12"
        dateTo="2021-06"
        positionName="Junior AML specialist"
        description={`
        - Developed an internal risk score automatic calculator
        
        - Conducted EDD reviews for high risk customers (e g. identifies the purpose of the account. confirms source of wealth, reviews adverse media, etc.) as part of on boarding and throughout the course of the relationship. 
        
        - Investigated names and accounts provided by multiple sources based on the AML Compliance office policies and procedures. Review and analyze KYC data gathered to assess reasonable cause to advance an alert tor an investigation. Conducted due diligence searches, gathered data. and recorded evidence from internal systems, the internet, and third-party databases.`}
        imageLocation="../bankeraLogo.svg"
        jobUrl="https://bankera.com/"
      />
      <Position
        dateFrom="2018-06"
        dateTo="2020-09"
        positionName="Waiter/Bartender"
        description={`
          - Knowledge of various different types of alcoholic drinks
          - Knowledge of cocktails and preparation methods
          - Ability to adapt in any situation
          - Flexibility working with a team and on my own
          - Story telling experiance about our Michelin star tier meals
        `}
        imageLocation="../VKLogo.png"
        jobUrl="https://www.vilakomoda.lt/en/"
      />
      <Position
        dateFrom="2008-06"
        dateTo="2017-09"
        positionName="Salesman"
        description="Tons of various experience since I was 8 by selling newspapers, tea, ice-cream, 
        fruits and working in a children theme park during the summer breaks"
        imageLocation=""
        jobUrl=""
      />
    </>
  );
}
